<div class="flex flex-col items-center mx-auto overflow-y-auto w-full h-full p-0.5">
  <div class="w-full">
    <p class="text-3xl font-light leading-tight tracking-normal mb-3">
      Recover password
    </p>

    <p class="text-sm text-neutral-100 font-light leading-tight tracking-wide">
      Don't worry, happens to the best of us.
    </p>

    <form [formGroup]="forgotPasswordForm" class="w-full grid gap-6 grid-cols-1 mt-12 md:mt-8 mb-12 md:mb-8" action="#">
      @if (isSubmitted && forgotPasswordForm.invalid) {
        <div class="w-full bg-[#9730307f] h-10 border-l-2 border-l-error">
          <span class="text-xs min-h-full inline-flex items-center ml-3">{{ 'ERROR.INVALID_EMAIL.MESSAGE' | translate }}</span>
        </div>
      }

      <nrc-input-text
        [formControl]="forgotPasswordForm.controls.email"
        [type]="'email'"
        [name]="'forgot-password-email'"
        [id]="'forgot-password-email'"
        [label]="'Email'"
        [classList]="['bg-[#454545]', 'md:bg-neutral-900']"
        [invalidHint]="'ERROR.EMAIL_NOT_MATCHING.MESSAGE' | translate"
      />
    </form>

    <div class="flex justify-end">
      <nrc-button
        [label]="'Send recovery email'"
        (clickEvent)="forgotPassword()"
      />
    </div>
  </div>
</div>
